import { FILTER_TYPE } from 'components/FiltersBlock/types';

export const NETWORK_TYPE_FILTER = {
  label: 'Сеть',
  name: 'network_type',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/engineering_networks/network_types/?page=1',
};

export const NETWORK_TYPE_FILTER1 = {
  label: 'Сеть',
  name: 'en_type',
  type: FILTER_TYPE.SELECT,
  apiUrl: '/api/standards/engineering_networks/network_types/?page=1',
};

export const NETWORK_FILTER = (structure: number | undefined) => {
  return {
    label: 'Сеть',
    name: 'network',
    type: FILTER_TYPE.SELECT,
    apiUrl: structure ? `/api/standards/structures/${structure}/engineering_networks/?page=1` : '',
  };
};
